// extracted by mini-css-extract-plugin
export default {"wrapper":"u9C9k8","wrapper--mobile":"vgBbCf","message":"tEM55C"};